/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Architect_Output9Inputs */

const en_svc_ecommerce_amazon_tools_architect_output9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tooling blueprint`)
};

const ar_svc_ecommerce_amazon_tools_architect_output9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مخطط الأدوات`)
};

const bn_svc_ecommerce_amazon_tools_architect_output9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টুলিং নকশা`)
};

const de_svc_ecommerce_amazon_tools_architect_output9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tooling-Blaupause`)
};

const es_svc_ecommerce_amazon_tools_architect_output9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano de herramientas`)
};

const fr_svc_ecommerce_amazon_tools_architect_output9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan d'outillage`)
};

const pt_svc_ecommerce_amazon_tools_architect_output9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano de ferramentas`)
};

const zh_svc_ecommerce_amazon_tools_architect_output9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具蓝图`)
};

const tr_svc_ecommerce_amazon_tools_architect_output9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Araç planı`)
};

const ru_svc_ecommerce_amazon_tools_architect_output9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чертёж инструментов`)
};

const pl_svc_ecommerce_amazon_tools_architect_output9 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan narzędzi`)
};

/**
* | output |
* | --- |
* | "Tooling blueprint" |
*
* @param {Svc_Ecommerce_Amazon_Tools_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_architect_output9 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_architect_output9(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_architect_output9(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_architect_output9(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_architect_output9(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_architect_output9(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_architect_output9(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_architect_output9(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_architect_output9(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_architect_output9(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_architect_output9(inputs)
	return en_svc_ecommerce_amazon_tools_architect_output9(inputs)
});
export { svc_ecommerce_amazon_tools_architect_output9 as "svc_ecommerce-amazon-tools_ARCHITECT_output" }